import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { EngrainMap, EngrainMapViewMode, GeoLocationPermissionStatus } from '@chirp/react-engrain-map';
import EmptyState from '../../components/EmptyState';
import LoaderPro from '../../components/Loader/Loader';
import { ENGRAIN_API_KEY } from '../../config';
import { getPropertyEngrainMap } from '../../helpers/getPropertyEngrainMap';
import { PropertyMapResponse } from '../../typing';

const PropertyMap: React.FC = () => {
  const propertyId = useParams().propertyId as string;
  const { search } = useLocation();

  const [selectedUnits, setSelectedUnits] = useState<string[]>([]);
  const [propertyMap, setPropertyMap] = useState<PropertyMapResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [
    geoLocationPermissionStatus,
    setGeoLocationPermissionStatus,
  ] = useState<GeoLocationPermissionStatus>(GeoLocationPermissionStatus.UNKNOWN);

  useEffect(() => {
    const unitsQueryParam = search.replace('?', '');
    setSelectedUnits((!!unitsQueryParam ? unitsQueryParam.replace('units=', '') : '').split('+'));
    
    if (propertyId) {
      getPropertyEngrainMap(propertyId).then((data) => {
        if (data) {
          setPropertyMap(data.data);
          setLoading(false);
        }
      });
    }

  }, [propertyId, search]);

  if (loading) {
    return <LoaderPro />;
  }

  if (!propertyMap) {
    return <EmptyState subTitle="Property does not have map"/>;
  }

  return (
    <EngrainMap
      viewMode={EngrainMapViewMode.VIEW}
      mapId={propertyMap.externalMapId}
      apiKey={ENGRAIN_API_KEY}
      floorsData={propertyMap.externalFloors}
      unitsData={propertyMap.externalUnits}
      bookedUnits={selectedUnits.map(unitId => ({ unitId }))}
      unitColor={'#687987'}
      selectedUnitColor={'#0076CC'}
      accessPoints={[]}
      onApprovedLocationStatus={(status) => setGeoLocationPermissionStatus(status)}
      geoLocationPermissionStatus={geoLocationPermissionStatus}
    />
  );
};

export default PropertyMap;
